<template>
  <div class="h-dialogContainer">
    <form id='updateDev'>
    <div class="row h-row-inputBox">
      <div class="col-sm-6 h-col-inputBox">
        <div>
          <div class="h-inputLit"><span class="h-red-code">* </span>{{this.$t('Topo.devType')}}:</div>
          <ejs-dropdownlist
             name="devType"
            :placeholder="devTypePlaceholder"
            :dataSource="typeData"
            v-model="devinfo.typeCode"
            :fields="typeFields"
            :readonly="readDeviceType"
            :enabled="false"
            :noRecordsTemplate="noRecordsTemplate"
          ></ejs-dropdownlist>
        </div>
      </div>
      <div class="col-sm-6 h-col-inputBox">
        <div>
          <div class="h-inputLit"><span class="h-red-code">* </span>{{this.$t('Topo.devName')}}:</div>
          <input
            name="devName"
            class="e-input"
            :placeholder="devNamePlaceholder"
            type="text"
            v-model="devinfo.name"
          />
        </div>
      </div>
    </div>
    <div class="row h-row-inputBox">
      <div class="col-sm-6 h-col-inputBox">
        <div>
          <div class="h-inputLit"><span class="h-red-code">* </span>{{this.$t('Topo.devSoftVersion')}}:</div>
          <ejs-dropdownlist
             name="devSoftVersion"
            :placeholder="devSoftVersionPlaceholder"
            :dataSource="visionData"
            v-model="devinfo.softwareVersion"
            :fields="visonFields"
            :readonly="readSoftware"
             :enabled="false"
            :noRecordsTemplate="noRecordsTemplate"
          ></ejs-dropdownlist>
        </div>
      </div>
      <!-- 归属子网 -->
      <div class="col-sm-6 h-col-inputBox">
        <div v-if='true'>
          <div class="h-inputLit">{{this.$t('Topo.devBelongSubnet')}}:<i class=" icon hero-icon hero-icon-tips e-icons" style="font-size: 14px; line-height: 14px;color: #666;" :title="deviceSubnetTips"></i></div>
          <ejs-dropdownlist
            name="devAttriTrunk"
            :placeholder="devAttriSubnetPlaceholder"
            :dataSource="subnetList"
            v-model="devinfo.subnetId"
            :fields="subnetFields"
            :stateenabled="visonEnable"
            :readonly="readDevAttriSubnet"
            :noRecordsTemplate="noRecordsTemplate"
            :showClearButton="true"
          ></ejs-dropdownlist>
        </div>
      </div>
      <div class="col-sm-6 h-col-inputBox" v-if='devAttriTrunkFlag'>
        <div>
          <div class="h-inputLit">{{this.$t('Topo.devAttriTrunk')}}:</div>
          <ejs-dropdownlist
             name="devAttriTrunk"
            :placeholder="devAttriTrunkPlaceholder"
            :dataSource="trunkList"
            v-model="devinfo.clusterId"
            :fields="trunkFields"
            :readonly="readDevAttriTrunk"
            :noRecordsTemplate="noRecordsTemplate"
          ></ejs-dropdownlist>
        </div>
      </div>
    </div>
    <div class="row h-row-inputBox" v-show="showLocation">
      <div class="col-sm-6 h-col-inputBox">
        <div>
          <div class="h-inputLit">{{this.$t('Topo.longitude')}}:</div>
          <input name="devLongitude" :placeholder="devLongitudePlaceholder" v-model="devinfo.longitude" type="text" class="e-input"/>
        </div>
      </div>
      <div class="col-sm-6 h-col-inputBox">
        <div>
          <div class="h-inputLit">{{this.$t('Topo.latitude')}}:</div>
          <input name="devLatitude" :placeholder="devLatitudePlaceholder" v-model="devinfo.latitude" type="text" class="e-input"/>
        </div>
      </div>
    </div>
    <div class="row h-row-inputBox" v-show="showLocation">
      <div class="col-sm-6 h-col-inputBox">
        <div>
          <div class="h-inputLit">{{this.$t('Topo.altitude')}}:</div>
          <input name="devAltitude" :placeholder="devAltitudePlaceholder" v-model="devinfo.altitude" type="text" class="e-input"/>
        </div>
      </div>
    </div>
    <IPAddrList ref='ipAddrList'></IPAddrList>
    <div class="row h-row-inputBox">
      <div class="h-col-inputBox" style='margin-top:18px'>
        <div class="h-inputLit">{{this.$t('Topo.devDescription')}}:</div>
        <ejs-textbox  name="devDescription" multiline="true" :placeholder="devDescriptionPlaceholder" v-model="devinfo.description"></ejs-textbox>
      </div>
    </div>
    </form>
    <div class="h-clear-rowMg"></div>
  </div>
</template>

<script>
var IpPortstatus = '';
import { FormValidator } from '@syncfusion/ej2-vue-inputs';
import IPAddrList from './IPAddrList';
import { EventBus } from '../../plugins/eventBus';
var equipmentIPList = [];

export default {
  name: 'update-device',
  components: {
    IPAddrList,
  },
  data() {
    return {
      devNamePlaceholder: this.$t('Topo.devName'),
      devTypePlaceholder: this.$t('Topo.devType'),
      devThreadPlaceholder: this.$t('Topo.devThread'),
      devSoftVersionPlaceholder: this.$t('Topo.devSoftVersion'),
      devDescriptionPlaceholder: this.$t('Topo.devDescription'),
      devAttriTrunkPlaceholder: this.$t('Topo.noAttriTrunk'),
      devAttriSubnetPlaceholder: this.$t('Topo.devAttriSubnet'),
      commuIPPlaceholder: this.$t('Topo.devIp'),   
      commuPortPlaceholder: this.$t('Topo.devPort'),
      devLongitudePlaceholder: this.$t('Topo.longitudePlaceholder'), // 经度
      devLatitudePlaceholder: this.$t('Topo.latitudePlaceholder'),  // 纬度
      devAltitudePlaceholder: this.$t('Topo.altitudePlaceholder'),
      deviceSubnetTips: this.$t('Topo.deviceSubnetTips'),
      devinfo: {
        id: '',
        name: '',
        typeCode: 0,
        clusterId:'',
        positionX: 0,
        positionY: 0,
        longitude: '',
        latitude: '',
        altitude: '',
        ipPortData: [],
        equipmentIPList: [],
        softwareVersion: '',
        displaySoftwareVersion:'',
        description: '',
      },
      typeData: [],
      typeFields: { value: 'typeCode', text: 'nameKey' },
      visionData: [],
      visonFields: { value: 'softwareVersion', text: 'displaySoftwareVersion' },
      trunkList:[],
      subnetList: [], // 归属子网集合
      trunkFields: { value: 'clusterId', text: 'trunkName' },
      subnetFields: { value: 'id', text: 'name'},
      readDeviceType: true,
      readSoftware: true,
      readDevAttriTrunk: true,
      readDevAttriSubnet: false,
      devAttriTrunkFlag:false,
      visonEnable: true,
      showLocation: true,
      noRecordsTemplate:  this.$t('Topo.noData'),

      validationOption: {
        customPlacement(inputElement, errorElement) {
            errorElement.style.float = 'left';
            inputElement.parentElement.parentElement.appendChild(errorElement);
        },
        rules: {                    
            devType: {                        
                required: [true, `${this.$t('Pm.alertRequired')}`],
            },
            devName: {
                required: [true, `${this.$t('Pm.alertRequired')}`],
                regex: [/^(^\S)/, `${this.$t('Topo.noEmptyStart')}`],
                maxLength: [30, `${this.$t('Topo.topoMaxLength')}30`],
            },
            // devAttriTrunk: {                        
            //     required: [true, `${this.$t('Pm.alertRequired')}`],
            // },
            devSoftVersion: {
                required: [true, `${this.$t('Pm.alertRequired')}`],
            },
            // devIp2: {                        
            //     required: [true, `${this.$t('Pm.alertRequired')}`],
            //     regex: [/^(25[0-5]|2[0-4]\d|[0-1]?\d?\d)(\.(25[0-5]|2[0-4]\d|[0-1]?\d?\d)){3}$/, `${this.$t('Topo.ipIllegal')}`]
            // },
            // devPort2: {
            //     required: [true, `${this.$t('Pm.alertRequired')}`],
            //     regex: [/^(1(02[4-9]|0[3-9][0-9]|[1-9][0-9]{2})|[2-9][0-9]{3}|[1-5][0-9]{4}|6[0-4][0-9]{3}|65[0-4][0-9]{2}|655[0-2][0-9]|6553[0-5])$/, `${this.$t('Topo.portIllegal')}`],            
            //     // maxLength: [255, `${this.$t('Pm.alertMaxLength')}255`],
            // },
            // devIp3: {                        
            //     required: [true, `${this.$t('Pm.alertRequired')}`],
            //     regex: [/^(25[0-5]|2[0-4]\d|[0-1]?\d?\d)(\.(25[0-5]|2[0-4]\d|[0-1]?\d?\d)){3}$/, `${this.$t('Topo.ipIllegal')}`]
            // },
            // devPort3: {
            //     required: [true, `${this.$t('Pm.alertRequired')}`],
            //     regex: [/^(1(02[4-9]|0[3-9][0-9]|[1-9][0-9]{2})|[2-9][0-9]{3}|[1-5][0-9]{4}|6[0-4][0-9]{3}|65[0-4][0-9]{2}|655[0-2][0-9]|6553[0-5])$/, `${this.$t('Topo.portIllegal')}`],            
            //     // maxLength: [255, `${this.$t('Pm.alertMaxLength')}255`],
            // },
            devDescription: {            
                maxLength: [255, `${this.$t('Topo.topoMaxLength')}255`],
            },
            devLongitude: {
              regex: ['^(\\-|\\+)?\\d+(\\.\\d+)?$', `${this.$t('System.inputNumber')}`],
              range: [[-180, 180], `${this.$t('Topo.longitudeIllegal')}`],
            },
            devLatitude: {
              regex: ['^(\\-|\\+)?\\d+(\\.\\d+)?$', `${this.$t('System.inputNumber')}`],
              range: [[-90, 90], `${this.$t('Topo.latitudeIllegal')}`],
            },
            devAltitude: {
              regex: ['^(\\-|\\+)?\\d*$', `${this.$t('System.inputInteger')}`],
              range: [[-9999, 9999], `${this.$t('Topo.altitudeIllegal')}`],
            },
        }
      }, 
    };
  },
  mounted() {
    this.bindValidate();
    this.getSubnetList();
  },
  methods: {
    outputs(isFromGraph) {
      if (!this.validate()) {
        return;
      }
      //校验通信ip和端口
      const IpPortData = this.$refs.ipAddrList.getDatas();
    
      if(IpPortData === null){
        console.log('IpPortData === null')
        return;
      }
      const iPListTemp=[];
      for(var i in IpPortData){
        if(IpPortData[i].id ===''){  //id==''是新加的IP和端口
         iPListTemp.push({
            id: '', 
            ip: IpPortData[i].ipaddr, 
            port: parseInt(IpPortData[i].port), 
            service:''
            }) 
        }
        const obj = equipmentIPList.find((item) => item.id === IpPortData[i].id);  //id已经存在的是修改的IP和端口
        if(obj !== undefined){
            iPListTemp.push({
            id: obj.id, 
            ip: IpPortData[i].ipaddr, 
            port: parseInt(IpPortData[i].port), 
            service:obj.service,
            processCode:obj.processCode,
            equipmentId:obj.equipmentId,
            }) 
        }
      }
      this.devinfo.equipmentIPList = iPListTemp;
      const flag123 = this.threadIDMatch(this.devinfo.typeCode);
      if(!flag123){
        this.devinfo.equipmentIPList=[];
        return;
      }

      if(this.devinfo.typeCode === 10003 && this.devinfo.clusterId !== 'null') //有归属集群的MCS设备service是mcs
      {
         this.devinfo.equipmentIPList[0].service = 'mcs';
      }
      // if (isFromGraph) {
      //   this.devinfo.positionX = positionX;
      //   this.devinfo.positionY = positionY;
      // }
      const devInfo = {
        ...this.devinfo,
        typeCode: this.devinfo.typeCode.toString(),
      }
      // 修改网元
      this.axios.post('/lte/ems/topo/device/modifyDev', devInfo).then((response) => {
        if (response.data === undefined) {
          return;
        }
        if (response.status === 200) {
          if (response.data.errorCode === 'SUCCESS') {
            EventBus.$emit('toast', {type: 'success', content: this.$t('Track.success')});
            this.closeWindow();
            return;
          } else {
            EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
          }
        }
        //-- fixed fixed NM8000-8021
        //-- this.closeWindow();
      });
    },

    ondevAttriTrunk() {
      const This = this;
      const trunkListTemp=[];
      This.$axios.get('/lte/ems/topo/trunk/findAllTrunks').then(response => {
        if (response.data === undefined) {
          return;
        }
        if (response.status === 200) {
          if (response.data.errorCode === 'SUCCESS') {
            for(var i in response.data.resultVal){
              trunkListTemp.push({
                clusterId:response.data.resultVal[i].id + '',
                trunkName:response.data.resultVal[i].name
              })
            };
            trunkListTemp.push({
              clusterId: 'null',
              trunkName:this.$t('Topo.noAttriTrunk'),
            });
            This.trunkList = trunkListTemp;
          } else {
            This.trunkList=[];
            EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
          }
        }
      });
    },

    ondevAttriTrunkQuery(resolve) {
      const This = this;
      const trunkListTemp=[];
      This.$axios.get('/lte/ems/topo/trunk/findAllTrunks').then(response => {  
        if (response.data === undefined) {
          return;
        }
        if (response.status ===200) {
          if (response.data.errorCode === 'SUCCESS') {
            for(var i in response.data.resultVal){
              trunkListTemp.push({
                clusterId:response.data.resultVal[i].id + '',
                trunkName:response.data.resultVal[i].name
              })
            };
            trunkListTemp.push({
              clusterId: 'null',
              trunkName:this.$t('Topo.noAttriTrunk'),
            });
            This.trunkList = trunkListTemp;
            resolve();
          } else {
            This.trunkList=[];
            EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
          }
        }
      });
    },

    closeWindow() {
      console.log('close');
      this.$emit('close');
    },
    initData(devdata) {
      // 新建设备专用
      console.log('devdata',devdata)
      this.devinfo = {
          id: '',
          name: '',
          typeCode: '',
          clusterId:'',
          subnetId: '',
          positionX: 255,
          positionY: 256,
          equipmentIPList: [],
          softwareVersion: '',
          displaySoftwareVersion:'',
          description: ''
        }; 
      if(devdata !== undefined){
        //查设备类型
        const This = this;
        This.$axios.get('/lte/ems/topo/device/devType').then((response) => {
        if(response.data === undefined){
          return;
        }
        if( response.status ===200){
        if (response.data.errorCode === 'SUCCESS') {
          This.typeData = response.data.resultVal;
          devdata.clusterId = devdata.clusterId+'';
          const visionDataTemp = [];
          visionDataTemp.push({
                softwareVersion:devdata.softwareVersion,
                displaySoftwareVersion:devdata.displaySoftwareVersion
              }) 
          This.visionData = visionDataTemp;  
    //集群去掉了，不需要查归属集群
          // if(devdata.clusterId !== 'null' || devdata.typeCode === 10003){
          //   new Promise((resolve) => {
          // this.ondevAttriTrunkQuery(resolve);
          // }).then(() => {
          //     This.devinfo = devdata;
          //     equipmentIPList = devdata.equipmentIPList;
          //     console.log('This.devinfo',This.devinfo)
          //     console.log('equipmentIPList1',equipmentIPList)
          //   //调整IP和端口的数量
          //     const args = {
          //       typeCode: this.devinfo.typeCode,
          //     }
          //     this.$refs.ipAddrList.initArgs(args);
          //     this.$refs.ipAddrList.initDatas(this.devinfo.equipmentIPList);
          // });  
          // }
          // else{
              This.devinfo = devdata;
              equipmentIPList = devdata.equipmentIPList;
              console.log('equipmentIPList2',equipmentIPList)
              //调整IP和端口的数量
                const args = {
                  typeCode: this.devinfo.typeCode,
                }
                // this.$refs.ipAddrList.addBtnClick();
                this.$refs.ipAddrList.initArgs(args);
                this.$refs.ipAddrList.initDatas(equipmentIPList);
                if (this.devinfo.typeCode === 10004 || this.devinfo.typeCode === 10006 || this.devinfo.typeCode === 10007) {
                  this.showLocation = true;
                } else {
                  this.showLocation = false;
                }
          // } 
        } else {
          This.typeData = [];
          EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
        } }
      })
      }
      this.getSubnetList();
    },

    // 新建设备时去后台查设备类型
    queryDevType() {
      const This = this;
      const params={ };
      This.$axios.get('/lte/ems/topo/device/devType',params).then((response) => {
        if(response.data === undefined){
          return;
        }
        if( response.status ===200){
        if (response.data.errorCode === 'SUCCESS') {
          This.typeData = response.data.resultVal;
        } else {
          This.typeData = [];
          EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
        } }
      });
    },

    threadIDMatch(value) {
      // 设备类型与进程号绑定
       const This = this;   
      if (value === 10001 ) {
        this.devinfo.equipmentIPList[0].service = 'epc';
      }
      if (value === 10002) {
         this.devinfo.equipmentIPList[0].service = 'ims';
       }
      if (value === 10003) {
        this.devinfo.equipmentIPList[0].service = 'mcs';
      }
      if (value === 10004|| value === 10008) {
       this.devinfo.equipmentIPList[0].service = 'enodeb';
      }
      if (value === 10005 || value === 10006) {
          const len = this.devinfo.equipmentIPList.length;
          if(len === 1){
            this.devinfo.equipmentIPList[0].service = 'enodeb';
          }
          if(len === 2){
            console.log('0',this.devinfo.equipmentIPList[0].port)
            console.log('1',this.devinfo.equipmentIPList[1].port)
            this.devinfo.equipmentIPList[0].service = 'enodeb';
            this.devinfo.equipmentIPList[1].service = 'epc';
            if(this.devinfo.equipmentIPList[0].ip === this.devinfo.equipmentIPList[1].ip&&
            this.devinfo.equipmentIPList[0].port === this.devinfo.equipmentIPList[1].port){
              EventBus.$emit('toast', {type: 'error', content: this.$t('Topo.ipPortDup')});
              return false;
            }
          }
          if(len === 3){
            this.devinfo.equipmentIPList[0].service = 'enodeb';
            this.devinfo.equipmentIPList[1].service = 'etc';
            this.devinfo.equipmentIPList[2].service = 'etc';
            if((this.devinfo.equipmentIPList[0].ip === this.devinfo.equipmentIPList[1].ip&&
              this.devinfo.equipmentIPList[0].port === this.devinfo.equipmentIPList[1].port)||
              (this.devinfo.equipmentIPList[0].ip === this.devinfo.equipmentIPList[2].ip&&
              this.devinfo.equipmentIPList[0].port === this.devinfo.equipmentIPList[2].port)||
              (this.devinfo.equipmentIPList[1].ip === this.devinfo.equipmentIPList[2].ip&&
              this.devinfo.equipmentIPList[1].port === this.devinfo.equipmentIPList[2].port)
              ){
                EventBus.$emit('toast', {type: 'error', content: this.$t('Topo.ipPortDup')});
                return false;
              }
          }
      }
      if (value === 10007) {
        this.devinfo.equipmentIPList[0].service = 'bpdt';
      }
      return true;
    },
    bindValidate() {            
      this.formObj = new FormValidator('#updateDev', this.validationOption);
    },
    validate() {
      const formStatus = this.formObj.validate();
      return formStatus;
    },
    getSubnetList() {
      let role = false;
      this.$axios.get('/lte/ems/auth/findSystemRole').then(response => {
        if (response && response.status === 200 && response.data !== undefined) {
          role = response.data;
        }
        let username = '';
        let principal = sessionStorage.getItem('principal');
        if (!!principal) {
          let user = JSON.parse(principal);
          username = user.username;
        }
        if ((username == 'Eadmin') || role) {
          this.axios.post('/lte/ems/topo/subnet/findAllSubnet').then(response => {
            if (response && response.status === 200 && response.data.errorCode === 'SUCCESS') {
              if (response.data.resultVal && response.data.resultVal.length > 0) {
                this.subnetList = response.data.resultVal;
              }
            } else {
              console.log('查询全部子网异常!');
            }
          });
        } else {
          this.axios.get('/lte/ems/auth/findSubnetListByAuth').then(response => {
            if (response && response.status === 200) {
              if (response.data && response.data.length > 0) {
                this.subnetList = response.data;
              }
            } else {
              console.log('查询全部子网异常!');
            }
          });
        }
      });
    },
  }
};
</script>
